<template>
	<div>
		<b-form-checkbox :id="fieldInfo.id" v-model="proxyValue" switch size="lg" :disabled="!active">{{
			fieldInfo.text
		}}</b-form-checkbox>
		<b-form-invalid-feedback :id="`${fieldInfo.name}-feedback`">
			{{ errors[fieldInfo.name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
export default {
	props: {
		fieldInfo: {
			type: Object
		},
		value: {
			type: Boolean
		},
		errors: {
			type: Object
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		}
	},
	computed: {
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", this.fieldInfo.name);
			}
		}
	},
	methods: {
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		}
	},
	data() {
		return {
			active: true
		};
	},
	beforeMount() {
		this.active = typeof this.isActive == "function" ? this.isActive(null) : this.isActive;
	}
};
</script>
